<template>
  <div>
    <el-dialog title="Serviços adicionais" center :visible.sync="dialog.servicesadd" width="80%" top="2vh">
      <el-form :model="form">
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
            <el-form-item :label="$t('descricao')">
              <el-input v-model="form.content" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="10" :xl="10">
            <el-form-item :label="$t('valor')">
              <el-input type="number" v-model="form.value" maxlength="10">
                <el-button slot="append" type="default" @click="add()">Adicionar</el-button>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table :data="tableServices" stripe style="width: 100%" :default-sort="{ prop: 'content', order: 'ascending' }">
        <el-table-column prop="content" :label="$t('descricao')" />
        <el-table-column prop="value" :label="$t('valor')">
          <template slot-scope="scope">{{
            scope.row.value
            | currency("R$ ", 2, {
              thousandsSeparator: ".",
              decimalSeparator: ",",
            })
          }}</template>
        </el-table-column>

        <el-table-column label="#" width="180">
          <template slot-scope="scope">
            <el-button type="danger" icon="el-icon-delete" @click="remove(scope.$index)" circle></el-button>
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="save()">Salvar</el-button>
      </span>
    </el-dialog>

    <el-card shadow="always">
      <el-page-header v-if="id === ''" @back="back" title content="Gerar Fatura Avulsa"></el-page-header>
    </el-card>
    <el-card>
      <el-form :model="ruleForm" ref="ruleForm" label-width="180px" label-position="right">
        <el-row type="flex">
          <el-col :xs="24" :sm="24" :md="16" :lg="12" :xl="12">
            <el-form-item :label="$t('cliente')" :required="true">
              <CustomerList v-model="ruleForm.customer" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('vencimento')" prop="name">
          <el-date-picker v-model="ruleForm.start" type="date" unlink-panels format="dd/MM/yyyy"></el-date-picker>
        </el-form-item>
        <el-row type="flex">
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <el-form-item :label="$t('valor-a-cobrar')" maxlength="50" class="no-margin-bottom" :required="true">
              <el-input type="number" min="1" step="1" v-on:blur="calc" pattern="[0-9]"
                v-model="ruleForm.valuePricetable"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <el-form-item :label="$t('valor-servico-adicional')" prop="valueServicesAditional">
              <el-input type="number" min="1" step="1" disabled pattern="[0-9]" v-model="ruleForm.valueServicesAditional">
                <el-button slot="append" size="mini" type="info" icon="el-icon-plus" @click="show(ruleForm.customer)" />
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <el-form-item :label="$t('valor-total')" maxlength="50" class="no-margin-bottom" :required="true">
              <el-input type="number" min="1" step="1" disabled pattern="[0-9]" v-model="ruleForm.valueTotal"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <el-form-item>
              <el-checkbox v-model="ruleForm.limit">Adicionar valor como crédito ao cliente</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <br />
      <el-button type="primary" autofocus @click="submitForm('ruleForm')">{{
        $t("adicionar")
      }}</el-button>
    </el-card>
  </div>
</template> 
<script>
import { i18n } from "@/plugin/i18n";
import { InvoiceServices } from "@/services/customers/invoice.services";
import { UserService } from "@/services/users/user.services";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import ServicesList from "@/xpost/views/register/services/ServicesList";

export default {
  name: "InvoiceAdd",
  components: {
    ServicesList,
    CustomerList,
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
  data() {
    const today = new Date();
    return {
      id: "",
      user: { type: "1" },
      tableServices: [],
      dialog: {
        servicesadd: false,
      },
      current: "",
      form: {
        content: "",
        value: 0,
      },
      ruleForm: {
        start: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1),
        customer: "",
        valuePricetable: 0,
        valueServicesAditional: 0,
        valueTotal: 0,
        limit: false,
      },
    };
  },
  methods: {
    show(id) {
      const vm = this;
      vm.dialog.servicesadd = true;
    },
    save() {
      const vm = this;
      const total = vm.tableServices.reduce((a, b) => {
        return a + +b.value;
      }, 0);
      vm.ruleForm.valueServicesAditional = +total;
      vm.ruleForm.valueTotal = +vm.ruleForm.valuePricetable + +total;
      vm.dialog.servicesadd = false;
    },
    add() {
      const vm = this;
      vm.tableServices.push({
        id: vm.ruleForm.customer,
        serviceId: null,
        content: vm.form.content,
        value: vm.form.value,
      });
    },
    remove(index) {
      const vm = this;
      vm.tableServices.splice(index, 1);
    },
    back() {
      var vm = this;
      vm.$router.replace({
        name: "cockpit.admin.billing",
      });
    },
    calc() {
      const vm = this;
      const total = vm.tableServices.reduce((a, b) => {
        return a + +b.value;
      }, 0);
      vm.ruleForm.valueTotal = +vm.ruleForm.valuePricetable + +total;
    },
    submitForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const total = vm.tableServices.reduce((a, b) => {
            return a + +b.value;
          }, 0);
          vm.ruleForm.valueTotal = +vm.ruleForm.valuePricetable + +total;
          const loading = vm.$loading(vm.$options.loading);
          InvoiceServices.addSingle({
            dueAt: vm.ruleForm.start,
            customer: vm.ruleForm.customer,
            valuePricetable: vm.ruleForm.valuePricetable,
            servicesAditional: vm.tableServices,
            valueTotal: vm.ruleForm.valueTotal,
            limit: vm.ruleForm.limit,
          })
            .then((response) => {
              vm.$message({
                type: "success",
                message: i18n.tc("faturas-geradas-sucesso"),
              });
              vm.$refs[formName].resetFields();
            })
            .catch((error) => {
              vm.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style scoped>
.item-badge {
  margin-top: 10px;
  margin-right: 40px;
}

.discount {
  width: 80px !important;
}

@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}

.ni {
  color: #fff;
}

.txt-12 {
  font-size: 12px;
}
</style>
